export default class ContentClass {
  static getSearchCentersPageContents() {
    if (window?.API) {
      return window.API.node
      || window.API['screening-search-page']?.node
      || window.API['screening-results-page']?.node
      || window.API['vaccination-search-page']?.node
      || window.API['vaccination-results-page']?.node;
    }

    return {
      field_accordion_title: '',
      field_accordion_text: '',
      field_right_column_text: '',
    };
  }

  static getRogerVoiceInfo() {
    if (window.API?.['vaccination-search-page']?.rogervoice) {
      return window.API?.['vaccination-search-page']?.rogervoice;
    }
    return null;
  }
}
